import Inputmask from "inputmask";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("mask", (e, binding) => {
    Inputmask(binding.value).mask(e);
  });
});
